/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    /*修复IOS系统上面的时间不兼容*/
    if (time.toString().indexOf('-') > 0) {
        time = time.replace(/-/g, '/');
    }
    if (arguments.length === 0) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
            time = parseInt(time)
        }
        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        return value.toString().padStart(2, '0')
    })
    return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000
    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日' +
            d.getHours() +
            '时' +
            d.getMinutes() +
            '分'
        )
    }
}

/**
 * 计算两个时间段的差值
 * @param {boolean} type 默认为true使用当前的日期
 * @param {string} sTime 开始时间
 * @param {string} eTime  结束时间
 * @returns {Number}  返回两个时间的差值
 */
export function DateDifference(type = false, sTime, eTime) {
    let startTime = null;
    type ? startTime = new Date().getTime() : startTime = new Date(sTime).getTime();
    const endTime = new Date(eTime).getTime();
    const usedTime = endTime - startTime;  //两个时间戳相差的毫秒数
    return Math.floor(usedTime / (24 * 3600 * 1000));
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
        const name = decodeURIComponent($1)
        let val = decodeURIComponent($2)
        val = String(val)
        obj[name] = val
        return rs
    })
    return obj
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
    // returns the byte length of an utf8 string
    let s = str.length
    for (var i = str.length - 1; i >= 0; i--) {
        const code = str.charCodeAt(i)
        if (code > 0x7f && code <= 0x7ff) {
            s++
        } else if (code > 0x7ff && code <= 0xffff) s += 2
        if (code >= 0xDC00 && code <= 0xDFFF) i--
    }
    return s
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
    const newArray = []
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i])
        }
    }
    return newArray
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
    if (!json) return ''
    return cleanArray(
        Object.keys(json).map(key => {
            if (json[key] === undefined) return ''
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
        })
    ).join('&')
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
    const search = url.split('?')[1]
    if (!search) {
        return {}
    }
    return JSON.parse(
        '{"' +
        decodeURIComponent(search)
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"')
            .replace(/\+/g, ' ') +
        '"}'
    )
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
    const div = document.createElement('div')
    div.innerHTML = val
    return div.textContent || div.innerText
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
    if (typeof target !== 'object') {
        target = {}
    }
    if (Array.isArray(source)) {
        return source.slice()
    }
    Object.keys(source).forEach(property => {
        const sourceProperty = source[property]
        if (typeof sourceProperty === 'object') {
            target[property] = objectMerge(target[property], sourceProperty)
        } else {
            target[property] = sourceProperty
        }
    })
    return target
}

/*数组去重*/
export function uniqueArray(arr) {
    if (!Array.isArray(arr)) {
        console.log('type error!')
        return
    }
    let array = []
    for (let i = 0; i < arr.length; i++) {
        if (array.indexOf(arr[i]) === -1) {
            array.push(arr[i])
        }
    }
    return array
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
    if (!element || !className) {
        return
    }
    let classString = element.className
    const nameIndex = classString.indexOf(className)
    if (nameIndex === -1) {
        classString += '' + className
    } else {
        classString =
            classString.substr(0, nameIndex) +
            classString.substr(nameIndex + className.length)
    }
    element.className = classString
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
    if (type === 'start') {
        return new Date().getTime() - 3600 * 1000 * 24 * 90
    } else {
        return new Date(new Date().toDateString())
    }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
    let timeout, args, context, timestamp, result

    const later = function () {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if (last < wait && last > 0) {
            timeout = setTimeout(later, wait - last)
        } else {
            timeout = null
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if (!immediate) {
                result = func.apply(context, args)
                if (!timeout) context = args = null
            }
        }
    }

    return function (...args) {
        context = this
        timestamp = +new Date()
        const callNow = immediate && !timeout
        // 如果延时不存在，重新设定延时
        if (!timeout) timeout = setTimeout(later, wait)
        if (callNow) {
            result = func.apply(context, args)
            context = args = null
        }

        return result
    }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
    if (!source && typeof source !== 'object') {
        throw new Error('error arguments', 'deepClone')
    }
    const targetObj = source.constructor === Array ? [] : {}
    Object.keys(source).forEach(keys => {
        if (source[keys] && typeof source[keys] === 'object') {
            targetObj[keys] = deepClone(source[keys])
        } else {
            targetObj[keys] = source[keys]
        }
    })
    return targetObj
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
    return Array.from(new Set(arr))
}

/**
 * @returns {string}
 */
export function createUniqueString() {
    const timestamp = +new Date() + ''
    const randomNum = parseInt((1 + Math.random()) * 65536) + ''
    return (+(randomNum + timestamp)).toString(32)
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
    return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
    if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
    if (hasClass(ele, cls)) {
        const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
        ele.className = ele.className.replace(reg, ' ')
    }
}

/*手机号验证*/
export function regMobile() {
    return /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/ //手机验证
}

/*日期转换成时间戳*/
export function dateToTime(time) {
    return new Date(time).getTime()
}

/*
 * 输入正数
 * @param {number} valNum
 * @param {boolean} toFixed 保留两位小数标识
 * @param {number} decimal
*/
export function clearNoNum(valNum, toFixed = true, decimal = 2) {
    valNum = valNum.toString()
    valNum = valNum.replace(/[^\d.]/g, '') //清除"数字"和"."以外的字符
    valNum = valNum.replace(/^\./g, '') //验证第一个字符是数字
    if (toFixed) {//需要保留两位小数标识
        valNum = valNum.replace(/\.{2,}/g, '.') //只保留第一个, 清除多余的
        valNum = valNum.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        if (decimal === 2) {//只能输入两个小数
            valNum = valNum.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
        } else {//保留一位小数
            valNum = valNum.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3')
        }
        if (valNum.indexOf('.') < 0 && valNum !== '') {//以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的数字
            valNum = parseFloat(valNum)
        }
    } else {//返回整数
        valNum = valNum ? parseInt(valNum) : ''
    }
    return valNum
}

/*数字保持两位小数*/
export function numberKeepDecimals(val) {
    return val.toFixed(2)
}

/*下载静态资源
* * @param {string} fileLink 文件路径
 * @param {string} fileType 文件类型
 * */
export function downLoad(fileLink, fileType = 'jpg') {
    let link = document.createElement('a')
    link.download = `${new Date().getTime()}.${fileType}`
    link.href = process.env.VUE_APP_BASE_FILE + fileLink
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

/*压缩图片
 * @param {file} file
 * @param {quality} number
* */
export function compressorImg(file, quality = 0.3) {
    return new Promise((resolve, reject) => {
        // 指定图片的DataURL(图片的base64编码数据)
        let canvas = document.createElement('canvas'); // 创建Canvas对象(画布)
        let context = canvas.getContext('2d');
        let img = new Image();
        img.src = file.content;
        img.onload = function () {
            canvas.width = this.width;
            canvas.height = this.height;
            context.drawImage(img, 0, 0, this.width, this.height);  // 图片大小
            file.content = canvas.toDataURL(file.file.type, quality);   // 0.92为默认压缩质量
            resolve(base64ToFile(file.content))
        };
        img.onerror = function () {
            reject()
        }
    })
}

/*base64文件格式转换成File
* @param {data} base64
* */
export function base64ToFile(data) {
    let binary = atob(data.split(',')[1]);
    let mime = data.split(',')[0].match(/:(.*?);/)[1];
    let array = [];
    for (let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
    }
    let fileData = new Blob([new Uint8Array(array)], {
        type: mime,
    });
    return new File([fileData], `${new Date().getTime()}.jpg`, {type: mime});
}

/*
* 单位转换
* @param {num} 数字
* @param {decimals} 保留小数位数
* */
export function conversion(num, decimals = 1) {
    if (!num) {
        return {
            num: 0,
            unit: 'KG',
            decimals: 0
        }
    }
    num = num.toFixed(decimals).toString()
    let int = num.split('.')[0], unit, number
    const len = int.length
    if (len > 7) { // 转换成万吨
        number = num / Math.pow(10, 7)
        unit = '万吨'
    } else if (len >= 4) { // 转换成吨
        number = num / Math.pow(10, 3)
        unit = '吨'
    } else { // 转换成公斤
        number = num / 1
        unit = 'KG'
    }
    number = number.toFixed(decimals) * 100 / 100
    return {
        num: number,
        unit,
        decimals: number.toString().split('.')[1] ? decimals : 0
    }
}

export const yearPickerOptions = { //大于当前年不可选
    disabledDate: (time) => {
        let dateTime = new Date()
        let curYear = dateTime.getFullYear() + 1
        let date = new Date(curYear, 0, 0)
        let year = date.getFullYear()
        let currentDate = year.toString()
        let timeYear = time.getFullYear()
        let timeDate = timeYear.toString()
        return currentDate < timeDate
    }
}

export const monthPickerOptions = { //大于当前月份的日期不可选
    disabledDate: (time) => {
        let date = new Date()
        let year = date.getFullYear()
        let month = date.getMonth() + 1
        if (month >= 1 && month <= 9) {
            month = '0' + month
        }
        let currentDate = year.toString() + month.toString()
        let timeYear = time.getFullYear()
        let timeMonth = time.getMonth() + 1
        if (timeMonth >= 1 && timeMonth <= 9) {
            timeMonth = '0' + timeMonth
        }
        let timeDate = timeYear.toString() + timeMonth.toString()
        return currentDate < timeDate
    }
}

/**
 * @description 控制数字显示的小数位数，不四舍五入
 * @param num {Number} 要处理的数字
 * @param decimals {Number} 保留小数位数
 * @returns
 * */
export const numToFixed = (num, decimals = 0) => {
    if (!num) return 0
    if(num.toString().indexOf('.') === -1) return num
    return num.toFixed(decimals).toString()
}

/* 周日发邮件，新办证人员只能从周三开始*/
export const timePickerOptions = {
    disabledDate: (time) => {
        const date = new Date('')
        return time.getTime() < Date.now() + 3600 * 1000 * 24 * 2
    }
}

/**
 * 返回当前元素的文本内容
 * @parm {DOM} element 当前DOM元素
 */
export function selectText(element) {
    return element.innerText;
}

/**
 * @param {String} text 需要复制的内容
 * @return {Boolean} 复制成功:true或者复制失败:false  执行完函数后，按ctrl + v试试
 */
export function copyText(text, fn) {
    var textValue = document.createElement('textarea');
    textValue.setAttribute('readonly', 'readonly'); //设置只读属性防止手机上弹出软键盘
    textValue.value = text;
    document.body.appendChild(textValue); //将textarea添加为body子元素
    textValue.select();
    var res = document.execCommand('copy');
    document.body.removeChild(textValue);//移除DOM元素
    fn();
    return res;
}